export const historyJobSource = [
  {
    id: 1,
    position: "Senior Full Stack Developer",
    company: "TechVenture Inc",
    location: "San Francisco, CA",
    workType: "Hybrid",
    employmentType: "Full-time",
    startDate: "January 2023",
    endDate: "Present",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Led development of microservices architecture using Node.js and React, improving system scalability by 40%",
          id: "Memimpin pengembangan arsitektur microservices dengan Node.js dan React, meningkatkan skalabilitas sistem hingga 40%",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Implemented CI/CD pipelines using GitHub Actions and Docker, reducing deployment time by 60%",
          id: "Menerapkan pipeline CI/CD dengan GitHub Actions dan Docker, memangkas waktu deployment hingga 60%",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Mentored junior developers and conducted code reviews to maintain high code quality standards",
          id: "Membimbing developer junior dan melakukan code review untuk menjaga standar kualitas kode",
        },
      },
      {
        idDescription: 4,
        detail: {
          en: "Collaborated with product team to design and develop customer-facing dashboard using React and TypeScript",
          id: "Berkolaborasi dengan tim produk merancang dan membangun dashboard pelanggan dengan React dan TypeScript",
        },
      },
      {
        idDescription: 5,
        detail: {
          en: "Optimized database queries and implemented caching strategies, improving application performance by 50%",
          id: "Mengoptimasi query database dan menerapkan strategi caching, meningkatkan performa aplikasi hingga 50%",
        },
      },
    ],
  },
  {
    id: 2,
    position: "Front End Developer",
    company: "Digital Solutions Corp",
    location: "New York, NY",
    workType: "Remote",
    employmentType: "Full-time",
    startDate: "March 2021",
    endDate: "December 2022",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Developed responsive web applications using React, Vue.js, and modern CSS frameworks",
          id: "Mengembangkan aplikasi web responsif dengan React, Vue.js, dan framework CSS modern",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Built reusable component library used across multiple projects, reducing development time by 30%",
          id: "Membangun component library yang dipakai ulang di banyak proyek, memangkas waktu development hingga 30%",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Implemented state management solutions using Redux and Vuex for complex applications",
          id: "Menerapkan state management dengan Redux dan Vuex untuk aplikasi yang kompleks",
        },
      },
      {
        idDescription: 4,
        detail: {
          en: "Worked closely with UX/UI designers to translate designs into pixel-perfect implementations",
          id: "Bekerja erat dengan desainer UX/UI untuk mewujudkan desain secara presisi hingga ke piksel",
        },
      },
      {
        idDescription: 5,
        detail: {
          en: "Integrated RESTful APIs and GraphQL endpoints for seamless data flow",
          id: "Mengintegrasikan RESTful API dan endpoint GraphQL agar alur data berjalan mulus",
        },
      },
      {
        idDescription: 6,
        detail: {
          en: "Implemented unit and integration tests using Jest and React Testing Library",
          id: "Menulis unit test dan integration test dengan Jest dan React Testing Library",
        },
      },
    ],
  },
  {
    id: 3,
    position: "Junior Front End Developer",
    company: "StartupHub Technologies",
    location: "Austin, TX",
    workType: "Onsite",
    employmentType: "Full-time",
    startDate: "June 2019",
    endDate: "February 2021",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Developed and maintained multiple client-facing web applications using HTML, CSS, and JavaScript",
          id: "Mengembangkan dan memelihara berbagai aplikasi web untuk klien dengan HTML, CSS, dan JavaScript",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Collaborated with cross-functional teams to implement new features and enhancements",
          id: "Berkolaborasi dengan tim lintas fungsi untuk menghadirkan fitur baru dan peningkatan",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Created responsive layouts and ensured cross-browser compatibility",
          id: "Membuat layout responsif dan memastikan kompatibilitas lintas browser",
        },
      },
      {
        idDescription: 4,
        detail: {
          en: "Participated in agile development process including daily standups and sprint planning",
          id: "Terlibat dalam proses agile, termasuk daily standup dan sprint planning",
        },
      },
      {
        idDescription: 5,
        detail: {
          en: "Assisted in migrating legacy code to modern frameworks (React and Vue.js)",
          id: "Membantu migrasi kode lama ke framework modern (React dan Vue.js)",
        },
      },
      {
        idDescription: 6,
        detail: {
          en: "Contributed to internal documentation and best practices guidelines",
          id: "Berkontribusi pada dokumentasi internal dan pedoman best practice",
        },
      },
      {
        idDescription: 7,
        detail: {
          en: "Implemented accessibility standards (WCAG 2.1) across all projects",
          id: "Menerapkan standar aksesibilitas (WCAG 2.1) di semua proyek",
        },
      },
      {
        idDescription: 8,
        detail: {
          en: "Optimized web performance and reduced page load times by 35%",
          id: "Mengoptimasi performa web dan memangkas waktu muat halaman hingga 35%",
        },
      },
      {
        idDescription: 9,
        detail: {
          en: "Worked with Git version control and participated in code review processes",
          id: "Menggunakan Git untuk version control dan terlibat dalam proses code review",
        },
      },
    ],
  },
  {
    id: 4,
    position: "Web Development Intern",
    company: "InnovateWeb Studio",
    location: "Seattle, WA",
    workType: "Onsite",
    employmentType: "Internship",
    startDate: "January 2019",
    endDate: "May 2019",
    type: "professional",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Assisted in developing internal web applications using React and modern JavaScript",
          id: "Membantu mengembangkan aplikasi web internal dengan React dan JavaScript modern",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Learned and implemented Progressive Web App (PWA) features for improved user experience",
          id: "Mempelajari dan menerapkan fitur Progressive Web App (PWA) untuk pengalaman pengguna yang lebih baik",
        },
      },
    ],
  },
  {
    id: 5,
    position: "Full Stack Developer",
    company: "E-Commerce Solutions",
    location: "Remote",
    workType: "Remote",
    employmentType: "Freelance",
    startDate: "2024",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Developed mobile-responsive e-commerce platform using React and Node.js",
          id: "Mengembangkan platform e-commerce yang responsif di mobile dengan React dan Node.js",
        },
      },
    ],
  },
  {
    id: 6,
    position: "Front End Developer",
    company: "MarketPlace Pro",
    location: "Remote",
    workType: "Remote",
    employmentType: "Freelance",
    startDate: "2023",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Built marketplace platform using Next.js with server-side rendering",
          id: "Membangun platform marketplace dengan Next.js dan server-side rendering",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Implemented SEO optimization strategies for better search rankings",
          id: "Menerapkan strategi optimasi SEO untuk peringkat pencarian yang lebih baik",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Created admin dashboard for managing products, users, and transactions",
          id: "Membuat dashboard admin untuk mengelola produk, pengguna, dan transaksi",
        },
      },
    ],
  },
  {
    id: 7,
    position: "Front End Developer",
    company: "Creative Agency Co",
    location: "Remote",
    workType: "Remote",
    employmentType: "Freelance",
    startDate: "2022",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Designed and developed responsive landing pages using Vue.js 3",
          id: "Merancang dan membangun landing page responsif dengan Vue.js 3",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Created admin CMS for managing client information, transactions, and promotions",
          id: "Membuat CMS admin untuk mengelola data klien, transaksi, dan promosi",
        },
      },
    ],
  },
  {
    id: 8,
    position: "Front End Developer",
    company: "ChatConnect App",
    location: "Remote",
    workType: "Remote",
    employmentType: "Freelance",
    startDate: "2020",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Maintained and developed new features for messaging application using Vue.js 2",
          id: "Memelihara dan menambah fitur baru pada aplikasi pesan dengan Vue.js 2",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Migrated legacy codebase from Meteor.js to Vue.js 2",
          id: "Memigrasikan codebase lama dari Meteor.js ke Vue.js 2",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Enhanced business dashboard with real-time chat features and analytics",
          id: "Meningkatkan dashboard bisnis dengan fitur chat real-time dan analitik",
        },
      },
    ],
  },
  {
    id: 9,
    position: "Full Stack Developer",
    company: "CrowdFund Platform",
    location: "Remote",
    workType: "Remote",
    employmentType: "Freelance",
    startDate: "2019",
    endDate: "",
    type: "freelance",
    listDescription: [
      {
        idDescription: 1,
        detail: {
          en: "Built crowdfunding platform using Laravel framework with MySQL database",
          id: "Membangun platform crowdfunding dengan framework Laravel dan database MySQL",
        },
      },
      {
        idDescription: 2,
        detail: {
          en: "Integrated payment gateway for secure online transactions",
          id: "Mengintegrasikan payment gateway untuk transaksi online yang aman",
        },
      },
      {
        idDescription: 3,
        detail: {
          en: "Developed admin dashboard for campaign management and transaction monitoring",
          id: "Mengembangkan dashboard admin untuk manajemen kampanye dan pemantauan transaksi",
        },
      },
    ],
  },
];

const MONTHS_ID: Record<string, string> = {
  January: "Januari",
  February: "Februari",
  March: "Maret",
  April: "April",
  May: "Mei",
  June: "Juni",
  July: "Juli",
  August: "Agustus",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "Desember",
  Present: "Sekarang",
};

// Dates are stored in English ("January 2023", "Present"); translate the leading word for Indonesian.
export const formatJobDate = (date: string, lang: "en" | "id") =>
  lang === "id"
    ? date.replace(/^[A-Za-z]+/, (month) => MONTHS_ID[month] ?? month)
    : date;
